import { baseApi } from './baseApi';

// Types
export interface EnqueuePrintJobRequest {
  printType: string; // 'PreCheck' | 'Payment' | 'KitchenOrder' | 'CashCount' | 'CashRegisterClosure' | 'CashMovement'
  receiptData: any; // EscPosReceiptData shape
  printerConfigurationId?: string;
  copies?: number;
}

export interface EnqueueKitchenOrderPrintRequest {
  orderId: string;
  tableLabel: string;
  waiterName: string;
  items: {
    productId: string;
    productName: string;
    quantity: number;
    variants: string[];
    notes?: string;
    seatNumber?: number | null;
    productionCenterId?: string;
  }[];
}

export interface EnqueuePrintJobResult {
  jobIds: string[];
  warnings: string[];
}

export interface PrintJobStatus {
  id: string;
  status: string; // QUEUED, CLAIMED, PRINTING, COMPLETED, FAILED, CANCELLED, EXPIRED
  printType: string;
  queuedAt: string;
  claimedAt?: string;
  completedAt?: string;
  errorMessage?: string;
  printerName?: string;
}

// API
export const cloudPrintJobsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    enqueuePrintJob: builder.mutation<EnqueuePrintJobResult, EnqueuePrintJobRequest>({
      query: (body) => ({ url: '/cloud-print-jobs', method: 'POST', body }),
    }),
    enqueueKitchenOrder: builder.mutation<EnqueuePrintJobResult, EnqueueKitchenOrderPrintRequest>({
      query: (body) => ({ url: '/cloud-print-jobs/kitchen-order', method: 'POST', body }),
    }),
    getPrintJobStatus: builder.query<PrintJobStatus, string>({
      query: (id) => `/cloud-print-jobs/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'PrintJob', id }],
    }),
    getBatchPrintJobStatus: builder.query<PrintJobStatus[], string[]>({
      query: (ids) => `/cloud-print-jobs/batch-status?${ids.map(id => `ids=${id}`).join('&')}`,
    }),
    cancelPrintJob: builder.mutation<void, string>({
      query: (id) => ({ url: `/cloud-print-jobs/${id}/cancel`, method: 'PATCH' }),
      invalidatesTags: (_result, _error, id) => [{ type: 'PrintJob', id }],
    }),
  }),
});

export const {
  useEnqueuePrintJobMutation,
  useEnqueueKitchenOrderMutation,
  useGetPrintJobStatusQuery,
  useGetBatchPrintJobStatusQuery,
  useCancelPrintJobMutation,
} = cloudPrintJobsApi;
